import Vue from 'vue';
import Vuex from 'vuex';
import router from '../router';
import actsTraits from './acts/actsTraits';
import actsContent from './acts/actsContent';
import newACTSTraits from './acts/newACTSTraits';
import newACTSContent from './acts/newACTSContent';
import actsCharacters from './acts/actsCharacters';
import samsaraContent from './samsaraContent';
const api = require('../firebaseConfig.js');

Vue.use(Vuex);

const state = {
  redirect: '',
  user: false,
  admin: false,
  editMode: false,
  newVersion: true,
  contentTagging: true,
  username: '',
  id: '',
  users: []
};
const actions = {
  validateAccount({ dispatch, commit }, validateUser) {
    commit('setUsername', validateUser.name);
    commit('setID', validateUser.uid);
    api.users
      .doc(validateUser.uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          if (doc.data().admin) {
            commit('setAdmin', true);
          } else {
            commit('setAdmin', false);
          }
          if (doc.data().user) {
            commit('setUser', true);
          }
        } else {
          commit('setAdmin', false);
          dispatch('createUserAccount', validateUser);
        }
      })
      .then(() => {
        if (state.redirect !== '') {
          router.push({ name: state.redirect }).catch(() => {});
        }
      })
      .catch((error) => {
        console.log('Error retrieiving account information ' + error);
      });
  },
  createUserAccount({}, newUser) {
    api.users
      .doc(newUser.uid)
      .set(newUser)
      .catch((error) => {
        console.log('Error creating account ' + error);
      });
  },
  userLogout({ state, commit }) {
    commit('setAdmin', false);
    commit('setUsername', '');
    if (state.editMode) {
      commit('setEdit');
    }
  },
  fetchUsers({ state }) {
    state.users = [];
    api.users.get().then((querySnapshot) => {
      querySnapshot.forEach(function(doc) {
        const newUser = doc.data();
        state.users.push(newUser);
      });
    });
  },
  updateUser({ }, user) {
    api.users
      .doc(user.uid)
      .set(user)
      .catch((error) => {
        console.log('Error updating account ' + error);
      });
  },
  toggleTags({ commit }) {
    commit('setTagging');
  },
  toggleEdit({ commit }) {
    commit('setEdit');
  },
  toggleVersion({ commit }) {
    commit('setVersion');
  }
};

const mutations = {
  setAdmin(state, val) {
    state.admin = val;
  },
  setUser(state, val) {
    state.user = val;
  },
  setEdit(state) {
    state.editMode = !state.editMode;
  },
  setVersion(state) {
    state.newVersion = !state.newVersion;
  },
  setUsername(state, val) {
    state.username = val;
  },
  setID(state, val) {
    state.id = val;
  },
  setTagging(state) {
    state.contentTagging = !state.contentTagging;
    localStorage.contentTagging = state.contentTagging;
  }
};
const getters = {};
export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    actsTraits,
    actsContent,
    actsCharacters,
    samsaraContent,
    newACTSTraits,
    newACTSContent
  }
});
